import React from "react";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

export const LangSwitch = styled(({ thumbColor, hasWhiteHeaderBg, ...props }) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
  ({ theme, thumbColor, hasWhiteHeaderBg }) => ({
    width: 24,
    height: 14,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(10px)",
        "& .MuiSwitch-thumb": {
          // Condition to set thumb color to white when maximized
          backgroundColor: hasWhiteHeaderBg ? "#fff" : thumbColor || theme.palette.primary.main,
        },
        "& + .MuiSwitch-track": {
          backgroundColor: hasWhiteHeaderBg ? "#000" : "#fff",
          opacity: hasWhiteHeaderBg ? 0.38 : 1,
          border: 0,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 10,
      height: 10,
      backgroundColor: "#fff",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: hasWhiteHeaderBg ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.4)",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  })
);
